import { useItemContext } from '@/store/contexts/ItemContext'

/**
 * Item 관련 Custom Hook
 * ItemContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useItem() {
  return useItemContext()
}

